/**
 * Utility functions for handling profile picture URLs
 * Supports both local storage and Cloudflare R2 URLs
 */

const API_BASE_URL = process.env.REACT_APP_API_URL || 'http://localhost:5000';

/**
 * Generates the correct URL for a profile picture
 * Handles both R2 URLs (which start with https://) and local filenames
 */
export function getProfilePictureUrl(profilePicture: string | null | undefined): string | null {
  if (!profilePicture) {
    return null;
  }

  // If it's already a full URL (R2 or external), return as is
  if (profilePicture.startsWith('https://') || profilePicture.startsWith('http://')) {
    return profilePicture;
  }

  // If it's an R2 path (starts with profile-pictures/), use the API endpoint
  // The backend will handle serving from R2 or local storage
  if (profilePicture.startsWith('profile-pictures/')) {
    return `${API_BASE_URL}/api/profile/picture/${profilePicture}`;
  }

  // Legacy local filename - use the API endpoint
  return `${API_BASE_URL}/api/profile/picture/${profilePicture}`;
}

/**
 * Checks if a profile picture URL is from R2 storage
 */
export function isR2Url(profilePicture: string | null | undefined): boolean {
  if (!profilePicture) return false;
  return profilePicture.startsWith('profile-pictures/') || 
         profilePicture.includes('.r2.dev') || 
         profilePicture.includes('r2.cloudflarestorage.com');
}